import React, { Component } from 'react';
import { Col, Grid, Navbar, Row, Badge } from 'react-bootstrap';
import Modal from 'react-responsive-modal';
import Card from 'components/Card/Card.jsx';
import Button from '../../components/CustomButton/CustomButton';
import moment from 'moment';

//ag-grid
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import { AgGridReact } from 'ag-grid-react';
import localeText from './../../components/localeTextAgGrid';
import auth from '../../libCustom/auth';
import feathers from '../../feathers';
import nameClientCellRenderer from '../../components/CellRenderer/nameClientCellRenderer';
import nameFranchiseCellRenderer from '../../components/CellRenderer/nameFranchiseCellRenderer';
import salesInformationCellRenderer from '../../components/CellRenderer/salesInformationCellRenderer';
import ActionsButtonSalesCell from '../../components/CellRenderer/ActionsCellButtonSales';
import ActionsTotalTrips from '../../components/CellRenderer/ActionsTotalTripsCell';
import numeral from 'numeral';
import undefsafe from 'undefsafe';
import immutable from 'object-path-immutable';
import axios from 'axios';
import Loading from '../../components/Loading';

const formatCash = (params) => {
  return numeral(params.value).format('$0,00.00');
};

class ReportClientsIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        initialDate: '',
        finalDate: '',
        searchClient: '',
        filterPrecio: '',
      },
      data: [],
      showModalDetail: false,
      selectedRowData: null,
      loading: false,
      columnDefs: [
        {
          headerName: 'CLIENTE',
          field: 'clientInfo',
          cellRenderer: 'nameClientCellRenderer',
          width: 200,
        },
        {
          headerName: '# VECES QUE COMPRÓ',
          field: 'totalPurchases',
          cellRenderer: 'actionsTotalTrips',
          width: 160,
        },
        {
          headerName: 'CANTIDAD',
          field: 'totalAmount',
          valueFormatter: formatCash,
          width: 130,
        },
        {
          headerName: 'FECHAS DE VIAJES Y DESTINO',
          field: 'salesInformation',
          cellRenderer: 'salesInformationCellRenderer',
          width: 520,
          cellStyle: (params) => {
            return {
              'white-space': 'pre-wrap',
              'word-break': 'break-word',
              'line-height': '1.3',
              padding: '8px',
              display: 'flex',
              'align-items': 'center',
            };
          },
          cellClass: 'multiline-cell',
          autoHeight: true,
          wrapText: true,
          cellRendererParams: {
            suppressCount: true,
          },
        },
        {
          headerName: 'FRANQUICIA',
          field: 'franchiseInfo',
          cellRenderer: 'nameFranchiseCellRenderer',
        },
        {
          headerName: 'ACCIONES',
          cellRenderer: 'actionsButtonSalesCell',
        },
      ],
      context: { componentParent: this },
      frameworkComponents: {
        nameClientCellRenderer: nameClientCellRenderer,
        nameFranchiseCellRenderer: nameFranchiseCellRenderer,
        salesInformationCellRenderer: salesInformationCellRenderer,
        actionsButtonSalesCell: ActionsButtonSalesCell,
        actionsTotalTrips: ActionsTotalTrips,
      },
    };
  }

  loadAllData = async () => {
    const { franchiseId, roles } = auth.getCurrentUser();

    const query = {
      franchiseId,
    };

    const responseData = await feathers
      .service('clients-summary')
      .find({ query });

    this.setState({
      data: responseData,
    });
  };

  async componentWillMount() {
    await this.loadAllData();
  }

  searchClients = async () => {
    const { franchiseId, roles } = auth.getCurrentUser();

    this.setState({
      loading: true,
    });

    const { initialDate, finalDate, searchClient, filterPrecio } =
      this.state.formData;

    let franchiseIdFind = '';
    if (roles.includes('admin')) {
      franchiseIdFind = franchiseId;
    }

    const url = `${process.env.REACT_APP_URL_FEATHERS}/clients-summary?dateInit=${initialDate}&dataEnd=${finalDate}&nameClient=${searchClient}&filterPrecio=${filterPrecio}&franchiseId=${franchiseIdFind}`;

    const response = await axios.get(url);

    this.setState({
      data: response && response.data.length > 0 ? response.data : [],
      loading: false,
    });
  };

  clearFilter = async () => {
    this.setState({
      formData: {
        initialDate: '',
        finalDate: '',
        searchClient: '',
        filterPrecio: '',
      },
    });

    await this.loadAllData();
  };

  checkFilter = () => {
    const { initialDate, finalDate, searchClient, filterPrecio } =
      this.state.formData;

    return (
      initialDate !== '' ||
      finalDate !== '' ||
      (searchClient && searchClient.trim() !== '') ||
      filterPrecio !== ''
    );
  };

  getActiveFiltersText = () => {
    const { initialDate, finalDate, searchClient, filterPrecio } =
      this.state.formData;

    const filters = [];

    if (initialDate && finalDate) {
      filters.push(`Fechas`);
    }

    if (searchClient && searchClient.trim() !== '') {
      filters.push(`Clientes`);
    }

    if (filterPrecio !== '') {
      filters.push(`Compras arriba de`);
    }

    return filters.length > 0 ? filters.join(' | ') : 'Ninguno';
  };

  handleInputChange = async (path, value) => {
    console.log({ path, value });
    const newFormData = immutable.set(this.state.formData, path, value);

    this.setState({
      formData: newFormData,
    });
  };

  handleActionCellChange = (data) => {
    this.setState({
      showModalDetail: !this.state.showModalDetail,
      selectedRowData: data,
    });
  };

  onCloseModal = () => {
    this.setState({
      showModalDetail: false,
    });
  };

  validateNameClientName = (client) => {
    let firstName = '';
    let lastName = '';

    if (client && client[0] && client[0].firstName) {
      firstName = client[0].firstName;
    }

    if (client && client[0] && client[0].lastName) {
      lastName = client[0].lastName;
    }

    return firstName + ' ' + lastName;
  };

  render() {
    const {
      columnDefs,
      data,
      frameworkComponents,
      showModalDetail,
      selectedRowData,
      loading,
      formData,
    } = this.state;

    return (
      <div>
        <div className="main-content">
          {loading ? (
            <Loading />
          ) : (
            <Grid fluid>
              <Row>
                <Col md={12}>
                  <Card
                    title={
                      <div>
                        {'Reporte de Clientes '}{' '}
                        <div className="header-table">
                          <Navbar.Form className="navbar-search-form">
                            <h4
                              style={{
                                fontSize: '16px',
                                fontWeight: 600,
                                color: '#495057',
                                marginBottom: '16px',
                                paddingBottom: '8px',
                                borderBottom: '2px solid #e9ecef',
                              }}
                            >
                              Filtros de Búsqueda
                            </h4>
                            <div class="form-group">
                              <label>Fecha Inicio :</label>
                              <input
                                style={{ color: '#000000' }}
                                id="initialDate"
                                type="date"
                                className="form-control"
                                name="initialDate"
                                value={formData.initialDate}
                                onChange={(event) =>
                                  this.handleInputChange(
                                    'initialDate',
                                    event.target.value
                                  )
                                }
                              />
                            </div>

                            <div class="form-group">
                              <label class="form-group">Fecha Fin :</label>
                              <input
                                id="finaDate2"
                                style={{ color: '#000000' }}
                                type="date"
                                className="form-control"
                                name="finalDate2"
                                value={formData.finalDate}
                                onChange={(event) =>
                                  this.handleInputChange(
                                    'finalDate',
                                    event.target.value
                                  )
                                }
                              />
                            </div>

                            <div class="form-group">
                              <label
                                style={{
                                  fontWeight: '250',
                                  whiteSpace: 'nowrap',
                                }}
                              >
                                Cliente:
                              </label>
                              <input
                                id="cliente"
                                style={{ color: '#000000', minWidth: '200px' }}
                                type="text"
                                className="form-control"
                                name="cliente"
                                placeholder="Buscar cliente..."
                                value={formData.searchClient}
                                onChange={(event) =>
                                  this.handleInputChange(
                                    'searchClient',
                                    event.target.value
                                  )
                                }
                              />
                            </div>

                            <div class="form-group">
                              <label
                                style={{
                                  fontWeight: '250',
                                  whiteSpace: 'nowrap',
                                }}
                              >
                                Compras arriba de:
                              </label>
                              <input
                                id="compras"
                                style={{ color: '#000000', minWidth: '120px' }}
                                type="number"
                                className="form-control"
                                name="compras"
                                placeholder="$100,000"
                                min="0"
                                step="1000"
                                value={formData.filterPrecio}
                                onChange={(event) =>
                                  this.handleInputChange(
                                    'filterPrecio',
                                    event.target.value
                                  )
                                }
                              />
                            </div>

                            <button
                              type="button"
                              className="btn btn-primary"
                              style={{
                                backgroundColor: '#69a900',
                                border: '#69a900',
                                color: '#fff',
                                padding: '6px 20px',
                                fontWeight: '500',
                              }}
                              onClick={() => this.searchClients()}
                            >
                              Buscar
                            </button>

                            <div>
                              <span
                                d
                                style={{
                                  fontSize: '14px',
                                }}
                              >
                                Filtro activo: {this.getActiveFiltersText()}
                              </span>
                              <Button
                                style={{
                                  width: '5%',
                                  marginRight: '1px',
                                  borderColor: '#fff',
                                  color: 'red',
                                }}
                                disabled={!this.checkFilter()}
                                onClick={() => this.clearFilter()}
                              >
                                <i
                                  style={{
                                    fontSize: 22,
                                    color: 'red',
                                  }}
                                  className="fa fa-times"
                                />
                              </Button>

                              <h4
                                style={{
                                  borderBottom: '2px solid #e9ecef',
                                }}
                              />
                            </div>
                          </Navbar.Form>
                        </div>
                      </div>
                    }
                    content={
                      <div
                        id="myGrid"
                        style={{
                          height: '650px',
                          width: '100%',
                        }}
                        className="ag-theme-alpine"
                      >
                        <AgGridReact
                          columnDefs={columnDefs}
                          rowData={data}
                          onGridReady={this.onGridReady}
                          pagination={true}
                          paginationPageSize={100}
                          cacheBlockSize={100}
                          frameworkComponents={frameworkComponents}
                          suppressRowHoverHighlight={false}
                          context={this.state.context}
                          //animateRows={true}
                        />
                      </div>
                    }
                  ></Card>
                </Col>
              </Row>
            </Grid>
          )}
        </div>

        <Modal
          open={undefsafe(showModalDetail, 'flight') || false}
          onClose={this.onCloseModal}
          styles={{
            modal: { width: '100%' },
            overlay: { alignItems: 'flex-start' },
          }}
          closeOnOverlayClick={false}
        >
          <form
            ref={(ref) => {
              this.formAdd = ref;
            }}
          >
            <Grid fluid>
              <Row>
                <Col md={12}>
                  <h5>
                    {' '}
                    Detalle de Viajes -{' '}
                    {selectedRowData &&
                      selectedRowData.clientInfo &&
                      this.validateNameClientName(selectedRowData.clientInfo)}
                  </h5>
                </Col>
              </Row>

              <hr />

              <div
                style={{
                  backgroundColor: '#e8f4fd',
                  border: '1px solid #b8d4f0',
                  borderRadius: '8px',
                  padding: '20px',
                  margin: '10px 0',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                }}
              >
                <Row>
                  <Col md={6}>
                    <div className="form-group">
                      <label
                        style={{
                          color: '#666',
                          fontSize: '14px',
                          fontWeight: 'normal',
                          marginBottom: '5px',
                          display: 'block',
                        }}
                      >
                        Total de Viajes
                      </label>
                    </div>

                    <div className="form-group">
                      <label
                        style={{
                          color: '#2c5aa0',
                          fontSize: '28px',
                          fontWeight: 'bold',
                          margin: '0',
                          display: 'block',
                        }}
                      >
                        {selectedRowData && selectedRowData.totalPurchases
                          ? selectedRowData.totalPurchases
                          : 0}
                      </label>
                    </div>
                  </Col>
                </Row>
              </div>

              {/* Container 2: Monto Total */}
              <div
                style={{
                  backgroundColor: '#e8f6fb',
                  border: '1px solid #1F5BB2',
                  borderRadius: '8px',
                  padding: '20px',
                  margin: '10px 0',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                }}
              >
                <Row>
                  <Col md={12}>
                    <div className="form-group">
                      <label
                        style={{
                          color: '#666',
                          fontSize: '14px',
                          fontWeight: 'normal',
                          marginBottom: '5px',
                          display: 'block',
                        }}
                      >
                        Monto Total
                      </label>
                    </div>
                    <div className="form-group">
                      <label
                        style={{
                          color: '#4AA7D4',
                          fontSize: '28px',
                          fontWeight: 'bold',
                          margin: '0',
                          display: 'block',
                        }}
                      >
                        {selectedRowData && selectedRowData.totalAmount
                          ? numeral(selectedRowData.totalAmount).format(
                              '$0,0.00'
                            )
                          : '$0.00'}
                      </label>
                    </div>
                  </Col>
                </Row>
              </div>

              {/* Container 3:  Detalles por vuelos*/}
              {selectedRowData &&
                selectedRowData.salesFlights &&
                selectedRowData.salesFlights.length > 0 && (
                  <div
                    style={{
                      backgroundColor: '#ecfeff',
                      border: '1px solid #06b6d4',
                      borderRadius: '8px',
                      padding: '20px',
                      margin: '10px 0',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                    }}
                  >
                    <Row>
                      <Col md={12}>
                        <div className="form-group">
                          <label
                            style={{
                              color: '#666',
                              fontSize: '14px',
                              fontWeight: 'normal',
                              marginBottom: '5px',
                              display: 'block',
                            }}
                          >
                            Vuelos
                          </label>
                        </div>
                        <div className="form-group">
                          {selectedRowData.salesFlights.map((flight, index) => {
                            return (
                              <div>
                                {index > 0 && (
                                  <h4
                                    style={{
                                      borderBottom: '2px solid #aeb1b4ff',
                                    }}
                                  />
                                )}
                                <div>
                                  <label>
                                    Precio Venta:{' '}
                                    <Badge
                                      style={{ backgroundColor: '#0489B1' }}
                                    >
                                      {numeral(flight.price).format('$0,0.00')}
                                    </Badge>{' '}
                                  </label>
                                </div>

                                <div>
                                  <label>
                                    Precio Compra:{' '}
                                    <Badge
                                      style={{ backgroundColor: '#5FB404' }}
                                    >
                                      {numeral(flight.buyprice).format(
                                        '$0,0.00'
                                      )}
                                    </Badge>
                                  </label>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </Col>
                    </Row>
                  </div>
                )}

              {/* Container 3:  Detalles por vuelos*/}
              {selectedRowData &&
                selectedRowData.salesLodging &&
                selectedRowData.salesLodging.length > 0 && (
                  <div
                    style={{
                      backgroundColor: '#f0fdfa',
                      border: '1px solid #1F5BB2',
                      borderRadius: '8px',
                      padding: '20px',
                      margin: '10px 0',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                    }}
                  >
                    <Row>
                      <Col md={12}>
                        <div className="form-group">
                          <label
                            style={{
                              color: '#666',
                              fontSize: '14px',
                              fontWeight: 'normal',
                              marginBottom: '5px',
                              display: 'block',
                            }}
                          >
                            Hospedaje
                          </label>
                        </div>
                        <div className="form-group">
                          {selectedRowData.salesLodging.map(
                            (lodging, index) => {
                              return (
                                <div>
                                  {index > 0 && (
                                    <h4
                                      style={{
                                        borderBottom: '2px solid #aeb1b4ff',
                                      }}
                                    />
                                  )}
                                  <div>
                                    <label>
                                      Precio Venta:{' '}
                                      <Badge
                                        style={{ backgroundColor: '#0489B1' }}
                                      >
                                        {numeral(lodging.saleCost).format(
                                          '$0,0.00'
                                        )}
                                      </Badge>{' '}
                                    </label>
                                  </div>

                                  <div>
                                    <label>
                                      Precio Compra:{' '}
                                      <Badge
                                        style={{ backgroundColor: '#5FB404' }}
                                      >
                                        {numeral(lodging.purchaseCost).format(
                                          '$0,0.00'
                                        )}
                                      </Badge>
                                    </label>
                                  </div>
                                </div>
                              );
                            }
                          )}
                        </div>
                      </Col>
                    </Row>
                  </div>
                )}

              {/* Container 3:  Detalles por vuelos*/}
              {selectedRowData &&
                selectedRowData.salesOtherServices &&
                selectedRowData.salesOtherServices.length > 0 && (
                  <div
                    style={{
                      backgroundColor: '#f0fdf4',
                      border: '1px solid #1F5BB2',
                      borderRadius: '8px',
                      padding: '20px',
                      margin: '10px 0',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                    }}
                  >
                    <Row>
                      <Col md={12}>
                        <div className="form-group">
                          <label
                            style={{
                              color: '#666',
                              fontSize: '14px',
                              fontWeight: 'normal',
                              marginBottom: '5px',
                              display: 'block',
                            }}
                          >
                            Otros Servicios
                          </label>
                        </div>
                        <div className="form-group">
                          {selectedRowData.salesOtherServices.map(
                            (otherService, index) => {
                              return (
                                <div>
                                  {index > 0 && (
                                    <h4
                                      style={{
                                        borderBottom: '2px solid #aeb1b4ff',
                                      }}
                                    />
                                  )}
                                  <div>
                                    <label>
                                      Precio Venta:{' '}
                                      <Badge
                                        style={{ backgroundColor: '#0489B1' }}
                                      >
                                        {numeral(otherService.price).format(
                                          '$0,0.00'
                                        )}
                                      </Badge>{' '}
                                    </label>
                                  </div>

                                  <div>
                                    <label>
                                      Precio Compra:{' '}
                                      <Badge
                                        style={{ backgroundColor: '#5FB404' }}
                                      >
                                        {numeral(otherService.buyprice).format(
                                          '$0,0.00'
                                        )}
                                      </Badge>
                                    </label>
                                  </div>
                                </div>
                              );
                            }
                          )}
                        </div>
                      </Col>
                    </Row>
                  </div>
                )}

              {/* Container 3:  Detalles por vuelos*/}
              {selectedRowData &&
                selectedRowData.salesPackages &&
                selectedRowData.salesPackages.length > 0 && (
                  <div
                    style={{
                      backgroundColor: '#f0f9ff',
                      border: '1px solid #1F5BB2',
                      borderRadius: '8px',
                      padding: '20px',
                      margin: '10px 0',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                    }}
                  >
                    <Row>
                      <Col md={12}>
                        <div className="form-group">
                          <label
                            style={{
                              color: '#666',
                              fontSize: '14px',
                              fontWeight: 'normal',
                              marginBottom: '5px',
                              display: 'block',
                            }}
                          >
                            Paquete
                          </label>
                        </div>
                        <div className="form-group">
                          {selectedRowData.salesPackages.map(
                            (packages, index) => {
                              return (
                                <div>
                                  {index > 0 && (
                                    <h4
                                      style={{
                                        borderBottom: '2px solid #aeb1b4ff',
                                      }}
                                    />
                                  )}
                                  <div>
                                    <label>
                                      Precio Venta:{' '}
                                      <Badge
                                        style={{ backgroundColor: '#0489B1' }}
                                      >
                                        {numeral(packages.price).format(
                                          '$0,0.00'
                                        )}
                                      </Badge>{' '}
                                    </label>
                                  </div>

                                  <div>
                                    <label>
                                      Precio Compra:{' '}
                                      <Badge
                                        style={{ backgroundColor: '#5FB404' }}
                                      >
                                        {numeral(packages.buyprice).format(
                                          '$0,0.00'
                                        )}
                                      </Badge>
                                    </label>
                                  </div>
                                </div>
                              );
                            }
                          )}
                        </div>
                      </Col>
                    </Row>
                  </div>
                )}
              <div
                style={{
                  backgroundColor: '#e6f9f9',
                  border: '1px solid #33B5B5',
                  borderRadius: '8px',
                  padding: '20px',
                  margin: '10px 0',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                }}
              >
                <Row>
                  <Col md={12}>
                    <div className="form-group">
                      <label
                        style={{
                          color: '#666',
                          fontSize: '14px',
                          fontWeight: 'normal',
                          marginBottom: '5px',
                          display: 'block',
                        }}
                      >
                        Franquicia
                      </label>
                    </div>
                    <div className="form-group">
                      <label
                        style={{
                          color: '#33B5B5',
                          fontSize: '28px',
                          fontWeight: 'bold',
                          margin: '0',
                          display: 'block',
                        }}
                      >
                        {selectedRowData && selectedRowData.franchiseInfo
                          ? selectedRowData.franchiseInfo.name
                          : 0}
                      </label>
                    </div>
                  </Col>
                </Row>
              </div>

              <h4>Historial de Viajes</h4>
              <div className="form-group">
                {selectedRowData &&
                  selectedRowData.salesInformation &&
                  selectedRowData.salesInformation.map((sale, index) => {
                    return (
                      <div
                        style={{
                          borderRadius: '8px',
                          padding: '20px',
                          margin: '10px 0',
                          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                        }}
                      >
                        <Row>
                          <Col md={12}>
                            <label>Viaje # {index + 1}</label>
                          </Col>

                          <Col md={12}>
                            <label>Fecha de inicio:</label>
                            {' ' +
                              moment(sale.departureDate).format('DD/MM/YYYY')}
                          </Col>

                          <Col md={12}>
                            <label>Fecha de Fin:</label>{' '}
                            {' ' + moment(sale.returnDate).format('DD/MM/YYYY')}
                          </Col>

                          <Col md={12}>
                            <label>Destino:</label>
                            {' ' + sale.destination}
                          </Col>
                        </Row>
                      </div>
                    );
                  })}
              </div>

              <Row>
                <Col md={12}>
                  <div className={'pull-right'} style={{ marginBottom: 15 }}>
                    <Button
                      bsStyle="primary"
                      style={{ marginRight: 10 }}
                      onClick={this.onCloseModal}
                    >
                      Cerrar
                    </Button>
                  </div>
                </Col>
              </Row>
            </Grid>
          </form>
        </Modal>
      </div>
    );
  }
}

export default ReportClientsIndex;



// WEBPACK FOOTER //
// ./src/views/ReportClients/ReportIndex.js